import { render, staticRenderFns } from "./CarriersOverview.vue?vue&type=template&id=6670746f&scoped=true&"
import script from "./CarriersOverview.vue?vue&type=script&lang=js&"
export * from "./CarriersOverview.vue?vue&type=script&lang=js&"
import style0 from "./CarriersOverview.vue?vue&type=style&index=0&id=6670746f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6670746f",
  null
  
)

export default component.exports